export const articleSlugs = [
  'cssbuy-spreadsheet-guide',
  'what-is-cssbuy-spreadsheet',
  'how-to-use-cssbuy-spreadsheet',
  'cssbuy-spreadsheet-for-beginners',
  'best-cssbuy-spreadsheet-categories',
  'cssbuy-spreadsheet-product-research',
  'cssbuy-spreadsheet-finds',
  'cssbuy-spreadsheet-sellers',
  'cssbuy-spreadsheet-links',
  'cssbuy-spreadsheet-faq',
];